import { createBrowserRouter, Navigate } from "react-router-dom";
import Login from "../Pages/AuthPages/Login/Login";
import PageNotFound from "../Exceptions/PageNotFound";
import NotAuthorized from "../Exceptions/NotAuthorized";
import RouteProtector from "./Layouts/IndexPageLayout";
import ForgotPassword from "../Pages/AuthPages/Forgot_Password/ForgotPassword";
import ResetPassword from "../Pages/AuthPages/Reset_Password/ResetPassword";
import Features from "../Components/Footer/Features";
import Pricing from "../Components/Footer/Pricing";
import Terms from "../Components/Footer/Terms";
import Privacy from "../Components/Footer/Privacy";
import Cookies from "../Components/Footer/Cookies";
import SystemStatus from "../Components/Footer/SystemStatus";
import CoverLayout from "../Pages/DataLayouts/CoverLayout";
import HelpCenterLayout from "../Pages/HelpCenter/HelpCenterLayout";
import HelpCenterHome from "../Pages/HelpCenter/HelpCenterHome";
import HelpSectionPage from "../Pages/HelpCenter/HelpSectionPage";

import FreeTrialPage from "../Pages/AuthPages/FreeTrailPage/TrialPage";
import OtpVerify from "../Pages/AuthPages/OtpVerify/OtpVerify";
import ClientSignup from "../Pages/AuthPages/ClientSignup/ClientSignup";

import MyProfilePage from "../Pages/MyProfile/MyProfilePage";
import ChangePassword from "../Pages/Settings/ChangePassword";
import UpdateCredentials from "../Pages/Settings/UpdateCredentials";
import OrganizationDetails from "../Pages/SignUpPages/OrganizationDetails";
import OrganizationAddInList from "../Pages/Orgnaization/Organisation/OrganizationAddInList";
import OrganizationProfile from "../Pages/Orgnaization/Profile/OrganizationProfile";
import OrganizationApplicationAccess from "../Pages/Orgnaization/Organisation/OrganizationApplicationAccess";
import {
  Configurations,
  getLeadActivityEmbedConfig,
} from "../Pages/EmsOptimized/FormConfigurations";
import CommonList from "../Pages/EmsOptimized/List/CommonList";
import ListPersonalizeView from "../Pages/EmsOptimized/List/ListPersonalizeView";
import CommonForm from "../Pages/EmsOptimized/Form/CommonForm";
import HomeEntry from "../Pages/HomeEntry";
import Dashboard from "../Pages/DashBoard/Dashboard";
import WalletApplicationsList from "../Pages/Wallet/WalletApplicationsList";
import WalletDetailPage from "../Pages/Wallet/WalletDetailPage";
import WalletClientsList from "../Pages/Wallet/WalletClientsList";
import WalletClientDetailPage from "../Pages/Wallet/WalletClientDetailPage";
import WalletLedgerPage from "../Pages/Wallet/WalletLedgerPage";
import WalletTransactionsPage from "../Pages/Wallet/WalletTransactionsPage";
import WalletTransactionDetailPage from "../Pages/Wallet/WalletTransactionDetailPage";
import CreditManagementPage from "../Pages/Wallet/CreditManagementPage";
import IntegrationPage from "../Pages/Wallet/IntegrationPage";
import ManualAdjustmentPage from "../Pages/Wallet/ManualAdjustmentPage";
import WalletNotificationsPage from "../Pages/Wallet/WalletNotificationsPage";
import WhiteLabelSettingsPage from "../Pages/Wallet/WhiteLabelSettingsPage";
import RolePermissionList from "../Pages/AdminUserManagement/ApplicationRolePermissionsList";
import RolePermissionForm from "../Pages/AdminUserManagement/ApplicationRolePermissionForm";
import UserRoleList from "../Pages/AdminUserManagement/ApplicationUserRolesList";
import UserRoleForm from "../Pages/AdminUserManagement/ApplicationUserRoleForm";
import Users from "../Pages/AdminUserManagement/ApplicationUsersList";
import UsersAdd from "../Pages/AdminUserManagement/ApplicationUserForm";
import UsersEdit from "../Pages/AdminUserManagement/ApplicationUserForm";
import ResourceUsersPage from "../Pages/Users/ResourceUsersPage";
import UserPersonalizeView from "../Pages/Users/UserPersonalizeView";
import UserRolePersonalizeView from "../Pages/User Management/UserRoles/UserRolePersonalizeView";
import UserPermissionList from "../Pages/User Management/UserPermission/UserPermissionList";
import UserPermissionForm from "../Pages/User Management/UserPermission/UserPermissionForm";
import ViewUserPermissionForm from "../Pages/User Management/UserPermission/ViewUserPermissionForm";
import OrganizationAddInForm from "../Pages/Orgnaization/Organisation/OrganizationAddInForm";
import OrganizationEntityList from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityList";
import OrganizationEntityForm from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityForm";
import OrganizationLocationList from "../Pages/Orgnaization/Location/OrganizationLocationList";
import OrganizationLocationForm from "../Pages/Orgnaization/Location/OrganizationLocationForm";
import OrganizationLocationPersonalizeView from "../Pages/Orgnaization/Location/OrganizationLocationPersonalizeView";
import OrganizationDepartmentsList from "../Pages/Orgnaization/Department/OrganizationDepartmentsList";
import OrganizationDepartmentForm from "../Pages/Orgnaization/Department/OrganizationDepartmentsForm";
import OrganizationDepartmentsPersonalizeView from "../Pages/Orgnaization/Department/OrganizationDepartmentsPersonalizeView";
import OrganizationDesignationsList from "../Pages/Orgnaization/Designations/OrganizationDesignationsList";
import OrganizationDesignationsForm from "../Pages/Orgnaization/Designations/OrganizationDesignationsForm";
import OrganizationDesignationsPersonalizeView from "../Pages/Orgnaization/Designations/OrganizationDesignationsPersonalizeView";
import MultiTableConfig from "../Pages/Orgnaization/DataGridSettings/MultiTableConfig";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RouteProtector>
        <HomeEntry />
      </RouteProtector>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <RouteProtector>
        <Dashboard />
      </RouteProtector>
    ),
  },
  {
    path: "/wallet/applications",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <WalletApplicationsList /> },
      { path: ":walletId", element: <WalletDetailPage /> },
    ],
  },
  {
    path: "/wallet/clients",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <WalletClientsList /> },
      { path: ":clientId", element: <WalletClientDetailPage /> },
    ],
  },
  {
    path: "/wallet/ledger",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <WalletLedgerPage /> }],
  },
  {
    path: "/wallet/transactions",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <WalletTransactionsPage /> },
      { path: ":walletId/:transactionId", element: <WalletTransactionDetailPage /> },
    ],
  },
  {
    path: "/wallet/credit",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <CreditManagementPage /> }],
  },
  {
    path: "/wallet/integration",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <IntegrationPage /> }],
  },
  {
    path: "/wallet/manual-adjustment",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <ManualAdjustmentPage /> }],
  },
  {
    path: "/wallet/notifications",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <WalletNotificationsPage /> }],
  },
  {
    path: "/wallet/white-label",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <WhiteLabelSettingsPage /> }],
  },
  {
    path: "/start-free-trial",
    element: <FreeTrialPage />,
  },
  {
    path: "/start-free-trial/verify-otp",
    element: <OtpVerify />,
  },
  {
    path: "/start-free-trial/org-details",
    element: <OrganizationDetails />,
  },
  {
    path: "/client-signup",
    element: <ClientSignup />,
  },
  {
    path: "/login",
    element: <Login title={"Login"} />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword title={"Forgot Password"} />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword title={"Reset Password"} />,
  },
  {
    path: "/my-profile",
    element: (
      <RouteProtector>
        <MyProfilePage />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/change-password",
    element: (
      <RouteProtector>
        <ChangePassword />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/update-credentials",
    element: (
      <RouteProtector>
        <UpdateCredentials />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/switcher",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <OrganizationAddInList /> }],
  },
  {
    path: "/organization/application-access",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <OrganizationApplicationAccess /> }],
  },

  ...Configurations?.map((item) => ({
    path: item.route,
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: (
          <CommonList
            key={`${item.route}-list`}
            {...item.ListProps}
            addButtonLabel={item.FormProps?.headerProps?.addMessage}
          />
        ),
      },
      {
        path: "add",
        element: (
          <CommonForm
            key={`${item.route}-add`}
            {...item.FormProps}
            embeddedLeadActivityConfig={
              getLeadActivityEmbedConfig?.() || undefined
            }
          />
        ),
      },
      {
        path: "edit/:id",
        element: (
          <CommonForm
            key={`${item.route}-edit`}
            {...item.FormProps}
            embeddedLeadActivityConfig={
              getLeadActivityEmbedConfig?.() || undefined
            }
          />
        ),
      },
      {
        path: "view/:id",
        element: (
          <CommonForm
            key={`${item.route}-view`}
            {...item.FormProps}
            embeddedLeadActivityConfig={
              getLeadActivityEmbedConfig?.() || undefined
            }
          />
        ),
      },
      {
        path: "personalize-view",
        element: <ListPersonalizeView />,
      },
    ],
  })),

  {
    path: "/organization/details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationAddInList /> },
      { path: "add", element: <OrganizationAddInForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationAddInForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationAddInForm mode="view" /> },
    ],
  },
  {
    path: "/organization/profile",
    element: (
      <RouteProtector>
        <OrganizationProfile />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/entity",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationEntityList /> },
      { path: "add", element: <OrganizationEntityForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationEntityForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationEntityForm mode="view" /> },
    ],
  },
  {
    path: "/organization/location",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationLocationList /> },
      {
        path: "personalize-view",
        element: <OrganizationLocationPersonalizeView />,
      },
      { path: "add", element: <OrganizationLocationForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationLocationForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationLocationForm mode="view" /> },
    ],
  },
  {
    path: "/organization/departments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDepartmentsList /> },
      {
        path: "personalize-view",
        element: <OrganizationDepartmentsPersonalizeView />,
      },
      { path: "add", element: <OrganizationDepartmentForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationDepartmentForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationDepartmentForm mode="view" /> },
    ],
  },
  {
    path: "/organization/department",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDepartmentsList /> },
      {
        path: "personalize-view",
        element: <OrganizationDepartmentsPersonalizeView />,
      },
      { path: "add", element: <OrganizationDepartmentForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationDepartmentForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationDepartmentForm mode="view" /> },
    ],
  },
  {
    path: "/organization/designation",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDesignationsList /> },
      {
        path: "personalize-view",
        element: <OrganizationDesignationsPersonalizeView />,
      },
      { path: "add", element: <OrganizationDesignationsForm mode="add" /> },
      {
        path: "edit/:id",
        element: <OrganizationDesignationsForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <OrganizationDesignationsForm mode="view" />,
      },
    ],
  },
  {
    path: "/organization/data-grid-settings",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <MultiTableConfig /> }],
  },
  {
    path: "/users",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <Users /> },
      { path: "personalize-view", element: <UserPersonalizeView /> },
      { path: "add", element: <UsersAdd mode="add" /> },
      { path: "edit/:id", element: <UsersEdit mode="edit" /> },
      { path: "view/:id", element: <UsersEdit mode="view" /> },
    ],
  },
  {
    path: "/resources/:roleSlug",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <ResourceUsersPage /> }],
  },
  {
    path: "/application/user-roles",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <UserRoleList /> },
      { path: "personalize-view", element: <UserRolePersonalizeView /> },
      { path: "add", element: <UserRoleForm mode="add" /> },
      { path: "edit/:id", element: <UserRoleForm mode="edit" /> },
      { path: "view/:id", element: <UserRoleForm mode="view" /> },
    ],
  },
  {
    path: "/application/user-role-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RolePermissionList /> },
      { path: "add", element: <RolePermissionForm mode="add" /> },
      { path: "view/:id", element: <RolePermissionForm mode="view" /> },
      { path: "edit/:id", element: <RolePermissionForm mode="edit" /> },
    ],
  },
  {
    path: "/application/user-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <UserPermissionList /> },
      { path: "add", element: <UserPermissionForm mode="add" /> },
      { path: "view/:id", element: <ViewUserPermissionForm mode="edit" /> },
      { path: "edit/:id", element: <UserPermissionForm mode="edit" /> },
    ],
  },
  {
    path: "/help",
    element: <HelpCenterLayout />,
    children: [
      { index: true, element: <HelpCenterHome /> },
      { path: ":sectionSlug", element: <HelpSectionPage /> },
    ],
  },
  { path: "/features", element: <Features /> },
  { path: "/pricing", element: <Pricing /> },
  { path: "/faq", element: <Navigate to="/help/faq" replace /> },
  { path: "/terms", element: <Terms /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "/cookies", element: <Cookies /> },
  { path: "/support", element: <Navigate to="/help/contact-support" replace /> },
  { path: "/system-status", element: <SystemStatus /> },
  { path: "/not-authorised", element: <NotAuthorized /> },
  { path: "*", element: <PageNotFound /> },
]);

export default router;
